import { Ban, RectangleGoggles } from "lucide-react";
import { renderToStaticMarkup } from "react-dom/server";

interface PinProps {
  selected?: boolean;
  closed?: boolean;
  /** Closed for good: muted pin with a "no entry" mark instead of the mask (shape and icon, not only colour). */
  permanent?: boolean;
}

/** Design `Pin` for a spot: `ocean` circle, mask icon, `warning` flag when closed. */
export function SpotPin({ selected, closed, permanent }: PinProps) {
  return (
    <div
      className={permanent ? "ds-pin ds-pin--permanent" : "ds-pin"}
      data-selected={selected ? "true" : "false"}
    >
      {permanent ? (
        <Ban size={16} strokeWidth={2} aria-hidden="true" />
      ) : (
        <RectangleGoggles size={16} strokeWidth={1.75} aria-hidden="true" />
      )}
      {closed && !permanent ? <span className="ds-pin__flag" /> : null}
    </div>
  );
}

/** Static markup for a Leaflet `divIcon` (Leaflet owns the DOM node, so no portals). */
export function spotPinHtml(props: PinProps): string {
  return renderToStaticMarkup(<SpotPin {...props} />);
}
